import React from 'react';
import IconSVG from './pen-to-square-regular-full.svg';
import styles from './EditIcon.module.scss';

function EditIcon(props) {
    const { className = '' } = props;

    return <IconSVG className={[styles.icon, className].join(' ')} />;
}

export default EditIcon;
